// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"globalFooter--2S8pb","links":"links--17HPh","copyright":"copyright--2X8ip","lightText":"lightText--q86ql"};